export type StoryCopy = {
  eyebrow?: string;
  title: string;
  description?: string;
  heading: "h1" | "h2";
  showStoreButton?: boolean;
  showScrollNote?: boolean;
};

export type StoryPhoto = {
  src: string;
  mobileSrc: string;
  alt: string;
  objectPosition: string;
};

export const APP_STORE_URL =
  "https://apps.apple.com/ru/app/plumme/id6759450972";

/**
 * The five text states and three photo states intentionally have different
 * counts. Their timing is matched to the original HTML prototype in
 * use-scroll-story.ts.
 */
export const STORY_COPIES: StoryCopy[] = [
  {
    title: "Plumme закрытое клубное пространство",
    description:
      "Экосистема клубов с сервисами для досуга, знакомств и общения",
    heading: "h1",
    showStoreButton: true,
    showScrollNote: true,
  },
  {
    eyebrow: "Клубы",
    title: "Выбирайте круг своих интересов",
    description:
      "Искусство, спорт, путешествия, гастрономия и десятки поводов оказаться в одном круге",
    heading: "h2",
  },
  {
    eyebrow: "События",
    title: "Насыщайте жизнь новыми впечатлениями",
    description:
      "Готовые планы для досуга, камерные мероприятия, подборки проверенных мест и сервисы для повышенного комфорта",
    heading: "h2",
  },
  {
    eyebrow: "Люди",
    title: "Расширяйте круг контактов и знакомьтесь с интересными людьми",
    description: "Комьюнити твоего уровня: люди, с которыми хочется общаться и проводить время",
    heading: "h2",
  },
  {
    eyebrow: "Вход в Plumme",
    title: "Возможно, ваш круг уже здесь",
    heading: "h2",
    showStoreButton: true,
  },
];

export const STORY_PHOTOS: StoryPhoto[] = [
  {
    src: "https://cdn.plumme.ru/static/background/Welcom_Screen3.jpg",
    mobileSrc: "https://cdn.plumme.ru/static/background/Welcom_Screen3.jpg",
    alt: "Камерное событие Plumme в галерее",
    objectPosition: "center center",
  },
  {
    src: "https://cdn.plumme.ru/static/background/01.jpg",
    mobileSrc: "https://cdn.plumme.ru/static/background/01.jpg",
    alt: "Готовый досуг Plumme",
    objectPosition: "center 38%",
  },
  {
    src: "https://cdn.plumme.ru/static/background/02.jpg",
    mobileSrc: "https://cdn.plumme.ru/static/background/02.jpg",
    alt: "Общение участников Plumme",
    objectPosition: "center 42%",
  },
];
